module.exports = __webpack_public_path__ + "img/KinokoTable59.bc954488.jpg";